/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/promotion';

/**
 * removePromotion
 * url - /checkout/{apiVersion}/cart/{cartId}/promotion?promotionId={promotionCode}
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.promotionCode
 */

const removePromotion = ({
    env, jwtToken, cartId, promotionCode,
}) => {
    const envObj = env || {};
    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;
    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}?promotionId=${promotionCode}`;

    return restClient.deleteRequest(envObj, resourcePage, jwtToken)
        .then((response) => response);
};

export default removePromotion;
